import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { MessageSquare, Send } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL + '/api';

export default function PortalNotes() {
  const [notes, setNotes] = useState([]);
  const [body, setBody] = useState('');
  const [saving, setSaving] = useState(false);
  const [loading, setLoading] = useState(true);

  const load = () => axios.get(`${API}/portal/notes`, { withCredentials: true })
    .then(r => setNotes(r.data || []))
    .finally(() => setLoading(false));

  useEffect(() => { load(); }, []);

  const save = async () => {
    if (!body.trim()) return;
    setSaving(true);
    try {
      await axios.post(`${API}/portal/notes`, { body }, { withCredentials: true });
      setBody('');
      toast.success('Note added');
      load();
    } catch { toast.error('Could not add note'); }
    finally { setSaving(false); }
  };

  return (
    <div className="space-y-4 max-w-3xl">
      <h1 className="font-heading text-2xl font-semibold text-zinc-50 flex items-center gap-2">
        <MessageSquare size={18} className="text-amber-400" /> Account Notes
      </h1>

      <div className="bg-zinc-900 border border-zinc-800 rounded-xl p-4">
        <textarea value={body} onChange={e => setBody(e.target.value)} rows={3}
          data-testid="note-input"
          placeholder="Write a note for our accounts team — a request, clarification, or payment detail."
          className="w-full bg-zinc-800 border border-zinc-700 rounded-lg px-3 py-2 text-zinc-50 text-sm focus:outline-none focus:border-amber-500" />
        <div className="flex justify-end mt-2">
          <button onClick={save} disabled={saving || !body.trim()} data-testid="post-note-btn"
            className="flex items-center gap-1.5 bg-amber-500 hover:bg-amber-400 text-black text-xs font-semibold px-4 py-2 rounded-lg disabled:opacity-50">
            <Send size={11} /> Post Note
          </button>
        </div>
      </div>

      <div className="space-y-2">
        {loading && <div className="text-zinc-500 text-sm">Loading…</div>}
        {!loading && notes.length === 0 && <div className="text-zinc-600 text-sm italic">No notes yet.</div>}
        {notes.map(n => (
          <div key={n.id} className="bg-zinc-900 border border-zinc-800 rounded-xl p-3" data-testid={`note-${n.id}`}>
            <div className="text-zinc-100 text-sm whitespace-pre-wrap">{n.body}</div>
            <div className="text-zinc-500 text-[10px] mt-1.5">
              {n.author_name} · {n.author_role} · {String(n.created_at).slice(0, 16).replace('T', ' ')}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
